import React, { useEffect } from 'react';
import { CLOSE_HEAVY_ICON } from '@Images';
import { useDispatch, useSelector } from 'react-redux';
import { CouponModalWrapper, InputContainer, InputContainerWrapper } from './styles';
import { ReferralCouponCards } from './ReferralCouponCards';
import InputApplyTextfield from '../input-apply-textfield';
import { saveNewCouponCode } from '@Redux/actions/transaction';
import { AppDispatch } from '../../store.type';
import { selectTransactionReducer } from '@Redux/selectors';
import { activateLoader } from '@Redux/actions/ui-trigger';
import { CouponsModalProps } from './utils';

const CouponsModal: React.FC<CouponsModalProps> = (props) => {
  const {
    onClose,
    couponCMSData,
    couponList,
    isAppliedFromTnxSummaryPage,
    onApplyCouponTxnSummaryPage
  } = props;
  const dispatch = useDispatch<AppDispatch>();
  const transactionReducer = useSelector(selectTransactionReducer);
  const isCouponCodeApplied = transactionReducer?.isNewCouponCodeApplied ?? false;

  // Use useEffect to handle the modal closing based on state changes
  useEffect(() => {
    if (isCouponCodeApplied) {
      onClose();
    }
  }, [isCouponCodeApplied, onClose]);

  const applyCoupon = (couponCode: string) => {
    dispatch(activateLoader());
    dispatch(saveNewCouponCode(couponCode));
    isAppliedFromTnxSummaryPage &&
      onApplyCouponTxnSummaryPage &&
      onApplyCouponTxnSummaryPage(couponCode);
  };

  return (
    <CouponModalWrapper>
      <img
        className="close-modal-icon"
        onClick={() => onClose()}
        src={CLOSE_HEAVY_ICON}
        alt="close-modal"
      />
      <div className="heading">{couponCMSData?.applyCouponTitle}</div>
      <InputContainerWrapper>
        <InputContainer>
          <InputApplyTextfield
            minLimitToActivateCTA={2}
            placeholder={couponCMSData?.applyCouponFieldPlaceholder}
            buttonText={couponCMSData?.applyCouponFieldCta}
            handleApply={applyCoupon}
          />
        </InputContainer>
      </InputContainerWrapper>
      {couponList?.length !== 0 && (
        <div className="container-heading">{couponCMSData?.couponsContainerHeading}</div>
      )}
      <ReferralCouponCards
        couponCMSData={couponCMSData}
        couponList={couponList}
        onApplyCouponTxnSummaryPage={onApplyCouponTxnSummaryPage}
      />
    </CouponModalWrapper>
  );
};

export default CouponsModal;
